import { render, staticRenderFns } from "./brainCardiovascularInfo.vue?vue&type=template&id=51a9917e"
import script from "./brainCardiovascularInfo.vue?vue&type=script&lang=js"
export * from "./brainCardiovascularInfo.vue?vue&type=script&lang=js"
import style0 from "./brainCardiovascularInfo.vue?vue&type=style&index=0&id=51a9917e&lang=sass"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('51a9917e')) {
      api.createRecord('51a9917e', component.options)
    } else {
      api.reload('51a9917e', component.options)
    }
    module.hot.accept("./brainCardiovascularInfo.vue?vue&type=template&id=51a9917e", function () {
      api.rerender('51a9917e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/hea/bcs/brainCardiovascularInfo.vue"
export default component.exports